module.exports = __webpack_public_path__ + "static/media/sat-icon.a031348e.svg";